// extracted by mini-css-extract-plugin
export default {"root":"ProblemsWidget_root__a44IG","sendButton":"ProblemsWidget_sendButton__3CK4r"};